import { ReactNode } from 'react';

import './Label.scss';

interface LabelProps {
  /** Associates the label with a control by id (e.g. a `Field`'s generated controlId). */
  readonly htmlFor?: string;
  /** Append " *" to mark a required field. */
  readonly mandatory?: boolean;
  readonly children: ReactNode;
}

/**
 * A form-control label. Standalone (not react-bootstrap `Form.Label`) so its typography is owned here and doesn't inherit
 * `.form-label` sizing/spacing. Used by `Field` (above a control) and `Switch`, so every control label reads the same.
 */
export const Label = ({ htmlFor, mandatory = false, children }: LabelProps) => (
  <label className="label" htmlFor={htmlFor}>
    {children}
    {mandatory ? ' *' : ''}
  </label>
);
